import React from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import CSCODashboardReportTile3 from "./CSCODashboardReportTile3";

class CSCODashboardReport3 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mFeatureRefId      : this.props.pFeatureRefId,
            mLayoutCode        : this.props.pLayoutCode,
            mLayoutType        : this.props.pLayoutType,
            mReportList        : this.props.pReportList || [],
            mReportGroups      : [],
            mActiveGroupIndex  : 0,
            mWindowStartIndex  : 0,
            mPopoutVisible     : false,
            mPopoutReport      : null
        };

        this.cfBuildGroups  = this.cfBuildGroups.bind(this);
        this.cfChangeGroup  = this.cfChangeGroup.bind(this);
        this.cfPrevReports  = this.cfPrevReports.bind(this);
        this.cfNextReports  = this.cfNextReports.bind(this);
        this.cfOpenPopout   = this.cfOpenPopout.bind(this);
        this.cfClosePopout  = this.cfClosePopout.bind(this);
    }

    componentDidMount() {
        const lGroups = this.cfBuildGroups(this.state.mReportList);
        this.setState({
            mReportGroups     : lGroups,
            mActiveGroupIndex : 0,
            mWindowStartIndex : 0
        });
    }

    componentDidUpdate(lPrevProps) {
        if (lPrevProps.pReportList !== this.props.pReportList) {
            const lList   = this.props.pReportList || [];
            const lGroups = this.cfBuildGroups(lList);

            this.setState({
                mReportList       : lList,
                mReportGroups     : lGroups,
                mActiveGroupIndex : 0,
                mWindowStartIndex : 0
            });
        }
    }

    /**
     * Group reports:
     *  - Prefer parent_report_
     *  - Else group_id_
     *  - Else UNGROUPED ("Dashboard")
     */
    cfBuildGroups(lReportList) {
        const lGroups   = [];
        const lGroupMap = {};

        if (lReportList && lReportList.length > 0) {
            // optional sort: parent_report_, sequence_
            // CSUtil.cfSort(lReportList, "parent_report_", "sequence_");

            for (let lInd = 0; lInd < lReportList.length; lInd++) {
                const lReport = lReportList[lInd];

                if(this.props.pFeatureRefId === lReport.parent_dashboard_layout_item_ref_id_) {
                    let lKey   = null;
                    let lLabel = null;

                    if (lReport.parent_report_) {
                        lKey   = lReport.parent_report_;
                        lLabel = lReport.parent_report_;
                    } else if (lReport.group_id_) {
                        lKey   = lReport.group_id_;
                        lLabel = lReport.group_id_;
                    } else {
                        lKey   = "UNGROUPED";
                        lLabel = "Dashboard";
                    }

                    let lGroup = lGroupMap[lKey];
                    if (!lGroup) {
                        lGroup = {
                            key     : lKey,
                            label   : lLabel,
                            reports : []
                        };
                        lGroupMap[lKey] = lGroup;
                        lGroups.push(lGroup);
                    }

                    lGroup.reports.push(lReport);
                }
            }
        }

        return lGroups;
    }

    cfChangeGroup(lIndex) {
        this.setState({
            mActiveGroupIndex : lIndex,
            mWindowStartIndex : 0
        });
    }

    // ◄ button, move window back by 2, never < 0
    cfPrevReports() {
        const lState  = this.state;
        const lGroups = lState.mReportGroups;

        if (!lGroups || lGroups.length === 0) return;

        const lGroup = lGroups[lState.mActiveGroupIndex];
        if (!lGroup) return;

        let lNewStart = lState.mWindowStartIndex - 2;
        if (lNewStart < 0) {
            lNewStart = 0;
        }

        this.setState({ mWindowStartIndex: lNewStart });
    }

    // ► button, Admissions 5 -> [1,2],[3,4],[5]; Academics 7 -> [1,2],[3,4],[5,6],[7]
    cfNextReports() {
        const lState  = this.state;
        const lGroups = lState.mReportGroups;

        if (!lGroups || lGroups.length === 0) return;

        const lGroup = lGroups[lState.mActiveGroupIndex];
        if (!lGroup) return;

        const lCount = (lGroup.reports) ? lGroup.reports.length : 0;
        if (lCount === 0) return;

        let lNewStart = lState.mWindowStartIndex + 2;

        if (lNewStart >= lCount) {
            // Last step → show only final report
            lNewStart = lCount - 1;
        }

        this.setState({ mWindowStartIndex: lNewStart });
    }

    cfOpenPopout(lReport) {
        this.setState({
            mPopoutVisible : true,
            mPopoutReport  : lReport
        });
    }

    cfClosePopout() {
        this.setState({
            mPopoutVisible : false,
            mPopoutReport  : null
        });
    }

    render() {
        const lGroups         = this.state.mReportGroups;
        const lActiveIndex    = this.state.mActiveGroupIndex;
        const lWindowStartIdx = this.state.mWindowStartIndex;
        const lPopoutVisible  = this.state.mPopoutVisible;
        const lPopoutReport   = this.state.mPopoutReport;

        if (!lGroups || lGroups.length === 0) {
            return null;
        }

        const lActiveGroup = lGroups[lActiveIndex] || lGroups[0];
        const lReports     = lActiveGroup.reports || [];
        const lCount       = lReports.length;

        const lStart       = (lWindowStartIdx < 0) ? 0 : lWindowStartIdx;
        const lVisible     = lReports.slice(lStart, lStart + 2);   // window size 2

        const lCanPrev     = (lStart > 0);
        const lCanNext     = (lStart < (lCount - 1));

        const lHasTabs     =
            (lGroups.length > 1) &&
            !(lGroups.length === 1 && lGroups[0].key === "UNGROUPED");

        return (
            <div style={{ width: "100%", paddingTop: "8px" }}>

                {/* Tabs + scroll buttons in ONE row */}
                <div
                    style={{
                        display        : "flex",
                        alignItems     : "center",
                        justifyContent : "space-between",
                        marginBottom   : "4px",
                        gap            : "4px"
                    }}
                >
                    {/* ◄ left arrow on extreme left */}
                    <Button
                        type="button"
                        icon="pi pi-chevron-left"
                        className="p-button-text p-button-rounded p-button-sm"
                        disabled={!lCanPrev}
                        onClick={this.cfPrevReports}
                    />

                    {/* Tabs in the center */}
                    <div
                        style={{
                            flex           : 1,
                            display        : "flex",
                            justifyContent : lHasTabs ? "center" : "flex-end",
                            gap            : "4px",
                            flexWrap       : "wrap"
                        }}
                    >
                        {lHasTabs && lGroups.map((lGrp, lIdx) => {
                            const lActive = (lIdx === lActiveIndex);
                            return (
                                <button
                                    key={lGrp.key + "_" + lIdx}
                                    type="button"
                                    onClick={() => this.cfChangeGroup(lIdx)}
                                    style={{
                                        padding       : "6px 14px",
                                        borderRadius  : "2px",
                                        border        : "1px solid " + (lActive ? "#2563eb" : "#d0d7e4"),
                                        background    : lActive ? "#e8f0fe" : "#ffffff",
                                        color         : lActive ? "#1d4ed8" : "#4b5563",
                                        fontSize      : "0.85rem",
                                        fontWeight    : lActive ? "600" : "500",
                                        cursor        : "pointer",
                                        whiteSpace    : "nowrap",
                                        boxShadow     : lActive ? "0 1px 4px rgba(37, 99, 235, 0.3)" : "none",
                                        transition    : "all 0.2s ease",
                                        minWidth      : "90px",
                                        textAlign     : "center"
                                    }}
                                    onMouseEnter={e => {
                                        e.target.style.background = lActive ? "#e8f0fe" : "#f3f4f6";
                                    }}
                                    onMouseLeave={e => {
                                        e.target.style.background = lActive ? "#e8f0fe" : "#ffffff";
                                    }}
                                >
                                    {lGrp.label}
                                </button>

                            );
                        })}
                    </div>

                    {/* ► right arrow on extreme right */}
                    <Button
                        type="button"
                        icon="pi pi-chevron-right"
                        className="p-button-text p-button-rounded p-button-sm"
                        disabled={!lCanNext}
                        onClick={this.cfNextReports}
                    />
                </div>

                {/* 2-column grid. alignItems:'start' prevents stretch/overflow */}
                <div
                    className="cs-dashboard-report-grid"
                    style={{
                        display             : "grid",
                        gridTemplateColumns : (lVisible.length === 1)
                                ? "1fr"
                                : "repeat(2, minmax(0, 1fr))",
                        gap                 : "8px",
                        alignItems          : "start"
                    }}
                >
                    {lVisible.map((lReport, lIdx) => (
                        <CSCODashboardReportTile3
                            key                 = {(lReport.id_ || lReport.report_name_) + "_" + lIdx}
                            pReport             = {lReport}
                            pIsDashboardReport  = {true}
                            pOnPopout           = {() => this.cfOpenPopout(lReport)}
                        />
                    ))}
                </div>

                {/* Popout dialog */}
                <Dialog
                    visible = {lPopoutVisible}
                    header  = {(lPopoutReport && (lPopoutReport.heading_ || lPopoutReport.report_name_)) || "Report"}
                    onHide  = {this.cfClosePopout}
                    style   = {{ width: "80vw", maxWidth: "1200px" }}
                    modal
                >
                    {
                        lPopoutReport &&
                        <div
                            style={{
                                height        : "75vh",           // a bit taller
                                display       : "flex",
                                flexDirection : "column"
                            }}
                        >
                            <CSCODashboardReportTile3
                                pReport             = {lPopoutReport}
                                pIsDashboardReport  = {false}     // tells chart "full mode"
                            />
                        </div>
                    }
                </Dialog>
            </div>
        );
    }
}

export default CSCODashboardReport3;
